import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { CollectionProgram } from '../collection/collection.domain';

export type DuplicatedCollection = Pick<
  CollectionProgram,
  'id' | 'name' | 'description' | 'influencerId'
>;

type DuplicateCollectionArgs = {
  collectionId: number;
  businessModel?: 'premium' | 'exclusive';
};

const duplicateCollection = async ({
  collectionId,
  businessModel,
}: DuplicateCollectionArgs): Promise<DuplicatedCollection> => {
  const token = auth.getToken();

  const response = await axios.post(
    getCreatorApiUrl(`/program/${collectionId}/duplicate`),
    businessModel ? { businessModel } : {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export const useDuplicateCollection = () =>
  useMutation({
    mutationFn: duplicateCollection,
  });
